import { useNavigate } from "react-router-dom";
import { Paths } from "../router/Paths";
import { useDispatch } from "react-redux";

export const useLogout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    // Clear all localStorage data
    localStorage.clear();

    // Dispatch reset action to clear Redux store
    dispatch({ type: "RESET" });

    // Redirect to login page
    navigate(Paths.login);
  };

  return handleLogout;
};
